<app-dialog heading="Editar aba" closeLabel="Fechar edição da aba" (closed)="close()">
  <div class="flex flex-col gap-3 lg:justify-between lg:flex-row">
    <!-- Formulário -->
    <div class="w-full p-5">
      <form class="flex flex-col gap-4" [formGroup]="form">
        <div class="form-group">
          <label for="name" class="input-label">Nome da Aba*</label>
          <input type="text" class="form-input" formControlName="tabName" id="name" />
        </div>

        <div class="form-group">
          <label for="number" class="input-label">Número no Metabase*</label>
          <input type="number" class="form-input" formControlName="dashboardNumber" />
        </div>

        <div class="form-group">
          <label for="companyId" class="input-label">Empresa</label>
          <ng-select
            notFoundText="Nenhum item encontrado"
            [items]="opcoesCompany"
            [searchable]="true"
            formControlName="companyId"
            bindLabel="name"
            bindValue="id"
            [multiple]="false"
          >
          </ng-select>
        </div>
      </form>
    </div>

    <!-- Menu Lateral -->
    <div
      class="relative flex flex-row justify-between gap-5 p-3 lg:px-10 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto sm:w-auto"
    >
      <button class="sm:px-2 lg:mb-5 btn w-48 btn--secondary" (click)="save()">Salvar Cadastro</button>
    </div>
  </div>
</app-dialog>
